import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const getStartSlotIdAtom = atom((get) => {
  const currentBooking = get(currentBookingAtom);
  return currentBooking?.startSlotId;
});
